import React from "react";
import { Typography } from "design_system/src";
import { ReactComponent as Hamburger } from "design_system/src/static/icons/filter-ascending.svg";
import { SelectedSkuFilters, SkuFilterOptions } from "models/inventory/helpers/skuFilters.helpers";
import SkuSearchInput from "./SkuSearchInput";
import SkuInputFilters from "./SkuInputFilters";

type SkuSideBarProps = {
  open: boolean;
  onChange: (changes: Partial<SelectedSkuFilters>) => void;
  filterOptions: SkuFilterOptions;
  loading: boolean;
};

const SkuSideBar: React.FC<SkuSideBarProps> = ({ open, onChange, filterOptions, loading }) => {
  return (
    <aside className="sticky display_none_mobile">
      <div
        className="m_t_lg display_flex flex_col"
        style={{
          maxHeight: "80vh",
          minHeight: "30vh",
          overflowY: "auto",
          overflowX: "hidden",
          position: "relative",
        }}
      >
        <div className="w_100_per">
          <div className="display_flex flex_align_center text_neutral_700 w_100_per p_x_lg">
            <Hamburger />
            <Typography
              className={`m_l_lg ${!open ? "display_none" : ""}`}
              weight="600"
              scale="small"
            >
              Filtros
            </Typography>
          </div>
          <div
            style={{
              borderTop: "1px solid rgb(199,199,199)",
              padding: 5,
              marginTop: 20,
              marginRight: 20,
              marginLeft: 20,
            }}
          />
          <SkuSearchInput onChange={onChange} />
        </div>
        <SkuInputFilters onChange={onChange} filterOptions={filterOptions} loading={loading} />
      </div>
    </aside>
  );
};

export default SkuSideBar;
